import React from 'react';
import { EnhancedProductCard } from '../shared/EnhancedProductCard';
import { PRODUCT_IMAGES } from '../../data/productImages';
import { useHorizontalScroll } from '../../lib/hooks/useHorizontalScroll';
import { haptics } from '../../lib/utils/haptics';
export function CustomersAlsoViewed() {
  const {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide
  } = useHorizontalScroll();
  const products = [{
    id: 1,
    name: 'Gold Standard 100% Whey Protein',
    brand: 'Optimum Nutrition',
    price: 29.99,
    originalPrice: 39.99,
    discount: 25,
    rating: 4.8,
    reviewCount: 324,
    image: PRODUCT_IMAGES[0],
    isBestSeller: true,
    isNew: false,
    expressDelivery: true
  }, {
    id: 2,
    name: 'ISO100 Hydrolyzed Protein Powder',
    brand: 'Dymatize',
    price: 24.99,
    originalPrice: 34.99,
    discount: 28,
    rating: 4.7,
    reviewCount: 256,
    image: PRODUCT_IMAGES[1],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 3,
    name: 'Original Pre Workout Powder',
    brand: 'C4',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.6,
    reviewCount: 189,
    image: PRODUCT_IMAGES[2],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 4,
    name: 'Nitro-Tech Whey Gold Protein Powder',
    brand: 'MuscleTech',
    price: 27.99,
    originalPrice: 39.99,
    discount: 30,
    rating: 4.5,
    reviewCount: 145,
    image: PRODUCT_IMAGES[3],
    isBestSeller: false,
    isNew: true,
    expressDelivery: true
  }, {
    id: 5,
    name: 'Syntha-6 Protein Powder',
    brand: 'BSN',
    price: 22.99,
    originalPrice: 31.99,
    discount: 28,
    rating: 4.4,
    reviewCount: 132,
    image: PRODUCT_IMAGES[4],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }, {
    id: 6,
    name: 'Amino Energy',
    brand: 'Optimum Nutrition',
    price: 16.99,
    originalPrice: 24.99,
    discount: 32,
    rating: 4.3,
    reviewCount: 98,
    image: PRODUCT_IMAGES[0],
    isBestSeller: false,
    isNew: false,
    expressDelivery: true
  }];
  const totalSlides = Math.ceil(products.length / 2);
  return <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-6" data-id="element-5125" data-mp="3emyv6va5hqf">
      <div className="flex items-center justify-between mb-4 md:mb-6" data-id="element-5126" data-mp="3ulhd66ezwipg">
        <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-5127" data-mp="3ul7m0fi7s5i6">
          Customers Also Viewed
        </h3>
        <a href="#" className="text-sm font-medium text-[#723881] bg-purple-100 px-3 py-1 rounded-full hover:bg-purple-200 transition-colors" data-id="element-5128" data-mp="db9glmsb7so8">
          View All
        </a>
      </div>
      {/* Mobile Slider */}
      {isMobile ? <div className="relative" data-id="element-5129" data-mp="2a6xitzmyo3jr">
          <div ref={scrollContainerRef} onScroll={handleScroll} className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide gap-3" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-5130" data-mp="2a7p168rjs4s3">
            {products.map(product => <div key={product.id} className="snap-start flex-shrink-0" style={{
          width: 'calc(50% - 6px)'
        }} data-id="element-5131" data-mp="kw3aectf1txf">
                <EnhancedProductCard product={product} data-id="element-5132" data-mp="azqh3g1s9i37" />
              </div>)}
          </div>
          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-5133" data-mp="3t6eppfw1kndm">
            {Array.from({
          length: totalSlides
        }).map((_, index) => <button key={index} onClick={() => scrollToSlide(index)} className={`h-2 rounded-full transition-all ${currentSlide === index ? 'w-6 bg-[#1E2B55]' : 'w-2 bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-5134" data-mp="1rdyw8pk84p4t" data-mpi={index} />)}
          </div>
        </div> :
    // Desktop Grid
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-5135" data-mp="3jdys6mlo83zp">
          {products.map(product => <EnhancedProductCard key={product.id} product={product} data-id="element-5136" data-mp="3eelx5eknbqm1" />)}
        </div>}
    </div>;
}